import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../buttons/Button";
import SecondaryButton from "../buttons/SecondaryButton";
// import S3ImageUpload from "../S3uploads/S3ImageUpload";
import { useDispatch } from "react-redux";
import CheckBoxWithLabel from "../checkbox/CheckBoxWithLabel";

const CustomersTermsAndConditions = ({ isOpen, onClose, secondaryButtonText, primaryButtonText, primaryButtonClassName, buttonLoading, handleSubmitButtonClick, buttonWidth }: any) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [checkBoxError, setCheckBoxError] = useState(false);
  const [error, setError] = useState("");
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleSubmit = () => {
    if(!isChecked) {
      setCheckBoxError(true);
    } else {
      setCheckBoxError(false);
    }
    if (!isChecked) {
      setError("Please agree to terms and conditions");
      // Scroll to the bottom of the scrollable container
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({
          top: scrollContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
      return;
    }
    setError("");
    handleSubmitButtonClick(""); // Signature disabled - will implement digital sign and fingerprint later
  };

  // Scroll to bottom when error is set
  useEffect(() => {
    if (error && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, [error]);
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 flex items-center p-10 justify-center bg-black bg-opacity-50 z-50"
        >
          <motion.div
            className="bg-white rounded-lg shadow-lg py-6 px-10 h-[589px] w-[906px] relative"
          >
            {/* Centered Header */}
            <h2 className="text-xl text-p_primary font-semibold pb-2 mt-4 mb-2 text-center">
              Terms and Conditions
            </h2>

            {/* Scrollable Content */}
            <div className="scrollBar overflow-y-auto h-[400px] my-4 pr-2" ref={scrollContainerRef}>
              <div className="">
                <h3 className="font-semibold text-lg mb-2">1. Introduction</h3>
                <p className="mb-2 ml-2 font-medium">1.1 These Terms and Conditions ("Terms") govern the registration and participation of
                  merchants ("Merchant", "you", "your") in the FinTech platform ("Platform") provided by Zood Pay
                  Telecom Services ("Zood Pay", "we", "us", "our").</p>
                <p className="mb-4 ml-2 font-medium">1.2 By registering as a customer ("Customer", "you", "your") on our Platform, you agree to comply with and be bound by these Terms. If you do not agree with these Terms, you must not register or use our Services.
                </p>

                <h3 className="font-semibold text-lg mb-2">2. Eligibility</h3>
                <p className="mb-2 ml-2 font-medium">2.1 To register as a Customer, you must:</p>
                <p className="mb-1 ml-4 font-medium">a. Be at least 18 years of age or the legal age of majority in your jurisdiction.
                </p>
                <p className="mb-1 ml-4 font-medium">b. Have the legal capacity to enter into a binding agreement with us.</p>
                <p className="mb-2 ml-4 font-medium">c. Provide accurate and complete information during the registration process.
                </p>
                <p className="mb-4 ml-2 font-medium">2.2 We reserve the right to reject any registration application at our sole discretion without
                  providing any reason.</p>

                <h3 className="font-semibold text-lg mb-2">3. Customer Obligations</h3>
                <p className="mb-2 ml-2 font-medium">3.1 You agree to:</p>
                <p className="mb-1 ml-4 font-medium">a. Provide accurate, current, and complete information during the registration process and maintain and promptly update such information.</p>
                <p className="mb-1 ml-4 font-medium">b. Comply with all applicable laws, regulations, and guidelines.</p>
                <p className="mb-2 ml-4 font-medium">c. Use the Platform solely for lawful purposes and in accordance with these Terms.</p>
                <p className="mb-4 ml-2 font-medium">3.2 You are responsible for maintaining the confidentiality of your account information, including
                  your username and password, and for all activities that occur under your account.</p>

                <h3 className="font-semibold text-lg mb-2">4. Services and Fees</h3>
                <p className="mb-4 ml-2 font-medium">4.1 We offer various financial services through our Platform. Detailed information about our Services is available on our website or mobile application.</p>
                <p className="mb-4 ml-2 font-medium">4.2 We reserve the right to change our services and fees at any time, and will provide notice of any changes on our Platform or through other means.</p>

                <h3 className="font-semibold text-lg mb-2">5. Privacy Policy</h3>
                <p className="mb-4 ml-2 font-medium">5.1 Your privacy is important to us. Our Privacy Policy, which is incorporated into these Terms by reference, explains how we collect, use, and protect your personal information. By using our Platform, you agree to the practices described in our Privacy Policy.</p>

                <h3 className="font-semibold text-lg mb-2">6. Prohibited Activities</h3>
                <p className="mb-2 ml-2 font-medium">6.1 You agree not to engage in any of the following Prohibited activities:</p>
                <p className="mb-1 ml-4 font-medium">a. Using the Platform for any illegal purpose or in violation of any local, state, national, or
                  international law.</p>
                <p className="mb-1 ml-4 font-medium">b. Impersonating any person or entity or falsely stating or otherwise misrepresenting your
                  affiliation with a person or entity.</p>
                <p className="mb-4 ml-4 font-medium">c. Interfering with or disrupting the Platform or servers or networks connected to the Platform.</p>

                <h3 className="font-semibold text-lg mb-2">7. Intellectual Property</h3>
                <p className="mb-2 ml-2 font-medium">7.1 All content and materials on the Platform, including but not limited to text, graphics, logos, and software, are the property of the Company or its licensors and are protected by intellectual property laws.
                </p>
                <p className="mb-4 ml-2 font-medium">7.2 You may not use, reproduce, or distribute any content or materials from the Platform without our prior written consent.
                </p>

                <h3 className="font-semibold text-lg mb-2">8. Limitation of Liability</h3>
                <p className="mb-4 ml-2 font-medium">8.1 To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of the Platform.</p>

                <h3 className="font-semibold text-lg mb-2">9. Indemnification</h3>
                <p className="mb-4 ml-2 font-medium">9.1 You agree to indemnify, defend, and hold harmless the Company, its affiliates, and their respective officers, directors, employees, and agents from and against any and all claims, liabilities, damages, losses, and expenses, including reasonable attorney's fees, arising out of or in any way connected with your use of the Platform or violation of these Terms.</p>

                <h3 className="font-semibold text-lg mb-2">10. Termination</h3>
                <p className="mb-2 ml-2 font-medium">10.1 We may terminate or suspend your account and access to the Platform at any time, with or without cause or notice.
                </p>
                <p className="mb-4 ml-2 font-medium">10.2 Upon termination, you must cease all use of the Platform and destroy any copies of content or materials obtained from the Platform.</p>

                <h3 className="font-semibold text-lg mb-2">11. Governing Law</h3>
                <p className="mb-4 ml-2 font-medium">11.1 These Terms shall be governed by and construed in accordance with the laws of Afghanistan, without regard to its conflict of law principles.
                </p>

                <h3 className="font-semibold text-lg mb-2">12. Dispute Resolution</h3>
                <p className="mb-4 ml-2 font-medium">12.1 Any disputes arising out of or relating to these Terms or the Platform shall be resolved through good faith negotiations. If the dispute cannot be resolved amicably, it shall be submitted to the exclusive jurisdiction of the courts of Afghanistan.</p>

                <h3 className="font-semibold text-lg mb-2">13. Amendments</h3>
                <p className="mb-4 ml-2 font-medium">13.1 We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting on the Platform. Your continued use of the Platform following the posting of changes constitutes your acceptance of such changes.</p>

                <h3 className="font-semibold text-lg mb-2">14. Miscellaneous</h3>
                <p className="mb-2 ml-2 font-medium">14.1 If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will remain in full force and effect.</p>
                <p className="mb-4 ml-2 font-medium">14.2 These Terms constitute the entire agreement between you and us regarding the subject matter hereof and supersede all prior or contemporaneous communications and proposals, whether oral or written, between you and us.</p>

                <h3 className="font-semibold text-lg mb-2">Contact Information</h3>
                <p className="mb-1 font-medium">If you have any questions about these Terms, please contact us at:</p>
                <p className="mb-1 font-medium">Zood Pay Telecom Services Company</p>
                <p className="mb-1 font-medium">Kabul - Afghanistan</p>
                <p className="mb-1 font-medium">coo@zood-pay.com</p>
                <p className="mb-4 font-medium">+93(0)782171333</p>
              </div>
              <div className=" flex items-center">
                <CheckBoxWithLabel
                  key='agreeTerms'
                  label={'I read and agree to the terms and conditions'}
                  handelCheckBox={() => {
                    setIsChecked(!isChecked);
                    setCheckBoxError(false)
                    if (!isChecked) {
                      setError("");
                    }
                  }}
                  checked={isChecked}
                  id={'agreeTerms'}
                  error={checkBoxError}
                />
              </div>
              <p className="text-negative ml-1 text-sm">{error ? "Please agree to terms and conditions" : ""}</p>
              {/* Signature upload disabled - will be implemented with digital sign and fingerprint later */}
              {/* <div className="mb-5 endOfThePage">
                <S3ImageUpload
                  heading=""
                  label="Upload your signature"
                  disabled={false}
                  upload_id={'signature'}
                  UploadPath={"uploads/signature"}
                  handleUpload={(file, upload_id) => handleInputChanges(file, upload_id)}
                  uploadedFile={signaturePath}
                  errorMessage={error}
                  required={true}
                  id={`signature`}
                  paddingTop="pt-2"
                />
              </div> */}
            </div>

            {/* Checkbox */}

            <div className={`flex mt-7 gap-6`}>
              <SecondaryButton
                buttonName={secondaryButtonText}
                className="px-4 py-2 h-fit"
                handleClick={onClose}
                testId="cancel-btn"
                buttonDisabled={false}
                loading={false}
              />
              <Button
                buttonName={primaryButtonText}
                className={`py-2.5 ${primaryButtonClassName} px-4 rounded-[6px] `}
                textSize={'text-large'}

                buttonOnclick={handleSubmit}
                testId={`${primaryButtonText.toLowerCase()}-btn`}
                loading={buttonLoading}
                buttonWidth={buttonWidth}
                buttonHight="h-[42px]"
              />
            </div>

          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CustomersTermsAndConditions;